import { notificationsReducer } from '@openx/utils/state/notifications/reducer.ts';
import { configureStore, type Store } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { session } from './state/session/reducer.ts';

const rootReducer = combineReducers({
  notifications: notificationsReducer,
  session,
});

export const store: Store = configureStore({
  reducer: rootReducer,
  devTools: true,
});
